<div [class]="visible ? 'flex flex-col h-full' : 'hidden'">
  <p-splitter class="grow w-full" layout="vertical" styleClass="h-full" [panelSizes]="[50, 50]">
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full">
        <div class="grow">
          <prox-ag-grid [gridOptions]="atugGridOptions" [rowData]="atugs"></prox-ag-grid>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate>
      <div class="flex flex-col w-full h-full mt-2">
        <div class="qb-panel-title">
          Users
        </div>
        <div class="flex flex-col grow">
          <div class="grow">
            <prox-ag-grid [gridOptions]="pugmGridOptions" [rowData]="pugms"></prox-ag-grid>
          </div>
        </div>
      </div>
    </ng-template>
  </p-splitter>
</div>